import { Products } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

import type { PackagePictureProps } from '../types';

const PackageImg = styled('img')(({ theme }) => ({
  width: '38px',
  height: '38px',
  marginLeft: '4px',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
}));

const IconWrapper = styled('div')(({ theme }) => ({
  width: '38px',
  height: '38px',
  backgroundColor: theme.palette.grey[100],
  marginLeft: '4px',
  borderRadius: theme.shape.borderRadius,
}));

const PackageIcon = styled(Products)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
  paddingTop: '4px',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[400],
}));

export function PackagePicture({ url }: PackagePictureProps) {
  const { getTestIdProps } = useTestId();

  if (url) {
    return (
      <PackageImg
        alt=""
        src={url}
      />
    );
  }

  return (
    <IconWrapper>
      <PackageIcon {...getTestIdProps('package-icon')} />
    </IconWrapper>
  );
}
